import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const playAlertSound = () => {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    const beep = (freq, start, duration) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.frequency.value = freq;
      osc.type = 'sine';
      gain.gain.setValueAtTime(0.3, ctx.currentTime + start);
      gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + start + duration);
      osc.start(ctx.currentTime + start);
      osc.stop(ctx.currentTime + start + duration);
    };
    beep(660, 0, 0.15);
    beep(880, 0.2, 0.15);
    beep(1050, 0.4, 0.25);
  } catch {}
};

const LeadReceivedModal = ({ alert, onDismiss }) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (alert) playAlertSound();
  }, [alert]);

  if (!alert) return null;

  const handleGoTo = () => {
    onDismiss();
    navigate(alert.leadId ? `/leads/${alert.leadId}` : '/leads');
  };

  return (
    <div
      onClick={onDismiss}
      style={{
        position: 'fixed', inset: 0, zIndex: 99999,
        background: 'rgba(0,0,0,0.75)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        animation: 'fadeIn 0.2s ease',
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: 'var(--card-bg)',
          border: '2px solid var(--success)',
          borderRadius: '16px',
          padding: '36px 32px',
          maxWidth: '420px',
          width: '90%',
          boxShadow: '0 0 60px rgba(34,197,94,0.4), 0 20px 60px rgba(0,0,0,0.5)',
          textAlign: 'center',
          animation: 'slideUp 0.25s ease',
        }}
      >
        <div style={{ fontSize: '52px', marginBottom: '12px', animation: 'pulse 1s ease infinite' }}>
          📥
        </div>

        <h2 style={{ color: 'var(--success)', fontSize: '22px', fontWeight: 700, margin: '0 0 8px' }}>
          New Lead Received
        </h2>

        <p style={{ color: 'var(--text)', fontSize: '16px', margin: '0 0 6px', fontWeight: 500 }}>
          {alert.message}
        </p>

        {alert.source && (
          <p style={{ color: 'var(--text-muted)', fontSize: '13px', margin: '0 0 6px' }}>
            Source: {alert.source}
          </p>
        )}

        <div style={{ display: 'flex', gap: '12px', marginTop: '28px', justifyContent: 'center' }}>
          <button
            onClick={onDismiss}
            style={{
              padding: '10px 24px', borderRadius: '8px',
              background: 'transparent', border: '1px solid var(--border)',
              color: 'var(--text-muted)', cursor: 'pointer', fontSize: '14px', fontWeight: 500, fontFamily: 'inherit',
            }}
          >
            Dismiss
          </button>
          <button
            onClick={handleGoTo}
            style={{
              padding: '10px 24px', borderRadius: '8px',
              background: 'var(--success)', border: 'none',
              color: '#fff', cursor: 'pointer', fontSize: '14px', fontWeight: 600, fontFamily: 'inherit',
            }}
          >
            View Lead
          </button>
        </div>
      </div>

      <style>{`
        @keyframes fadeIn { from { opacity: 0 } to { opacity: 1 } }
        @keyframes slideUp { from { transform: translateY(30px); opacity: 0 } to { transform: translateY(0); opacity: 1 } }
        @keyframes pulse { 0%,100% { transform: scale(1) } 50% { transform: scale(1.15) } }
      `}</style>
    </div>
  );
};

export default LeadReceivedModal;
